module.exports = __webpack_public_path__ + "static/media/shield-white.bf738e45.svg";